/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getMusicStreamingUrl} from '../api'

 export const useQueryGetMusicStreamingUrl = createReactQueryHook('getMusicStreamingUrl', getMusicStreamingUrl)
